<section id="halves-section" class="main-container px-lg-3" [style.background]="bgColor">
  <div class="container-fluid-lg px-3 py-5 p-lg-5">
    <div class="first_row row"
      [ngClass]="{'align-items-center':!this.topParagraph,'align-items-top':this.topParagraph}">
      <div class="col-lg-6 text-center text-lg-start rounded order-2 mt-3 mt-lg-0 order-lg-0"
        [ngClass]="{'order-lg-2 text-lg-end':this.imageToRight}">
        <img class="img-left img-fluid" [width]="imgWidth" [src]="imgUrl" alt="Imagen auxiliar de contenido" i18n-alt
          loading="lazy" />
      </div>
      <div class="img_paragraph col-lg-6 text-start">
        <h2 [innerHTML]="infoHeaderTemplate" class="mt-lg-0 shrink-text h1_mask"></h2>
        <div [innerHtml]="paragraphTemplate" class=" p-0 pt-md-5 pe-md-5"></div>
        <a *ngIf="!hrefBtn&&!fragment&&btnLink" [class]="'button mt-5 '+btnBg"
          [routerLink]="btnLink">{{textOnButton}}</a>
        <a *ngIf="fragment" [class]="'button mt-5 '+btnBg" [routerLink]="btnLink"
          [fragment]="fragment">{{textOnButton}}</a>
        <a *ngIf="hrefBtn" [class]="'button mt-5 '+btnBg" [href]="hrefBtn" download="Microdosis y Ciencia.pdf"
          target="_blank">{{textOnButton}}</a>
      </div>
    </div>
  </div>
</section>